// import './sentry';

//
import './components/ProductTeaser.svelte';
import './components/ShoppingCart.svelte';
import { register } from 'swiper/element/bundle';
import 'media-chrome/dist/media-controller';
import 'media-chrome/dist/media-play-button';
import 'media-chrome/dist/media-control-bar';
import 'media-chrome/dist/media-mute-button';
import 'media-chrome/dist/media-volume-range';
import 'media-chrome/dist/media-time-display';
import 'media-chrome/dist/media-time-range';
import 'media-chrome/dist/media-fullscreen-button';
import 'hls-video-element';
import { Accordion } from './utils/accordion';

register();

Array.from(document.querySelectorAll("#navigation a[href*='#']")).forEach(
	hashLink =>
		hashLink.addEventListener('click', () => {
			hashLink.closest('dialog')?.close();
		}),
);
// Uncomment to enhance details/summary elements
const accordions = Array.from(document.querySelectorAll('.accordion details'));
accordions.forEach(accordion => {
	new Accordion(accordion);
});

const videos = Array.from(document.querySelectorAll('hls-video:not([muted])'));
videos.forEach(video => {
	video.addEventListener('play', () => {
		if (!video.parentElement?.hasAttribute('mediahasplayed')) {
			video.parentElement?.requestFullscreen();
		}
	});
});

// Add animation to page builder blocks
const blocks = Array.from(
	document.querySelectorAll('main > .flow > :not(button)'),
);
const observer = new IntersectionObserver(
	entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.remove('not-intersecting');
			}
		});
	},
	{ threshold: [0, 1], rootMargin: '-80px' },
);
blocks.forEach(block => {
	block.classList.add('animate-on-intersection');
	block.classList.add('not-intersecting');
	observer.observe(block);
});

const videoObserver = new IntersectionObserver(
	entries => {
		entries.forEach(entry => {
			const { target } = entry;
			if (target.tagName === 'HLS-VIDEO') {
				if (entry.isIntersecting) {
					if (target.dataset.src) {
						target.setAttribute('src', target.dataset.src);
						target.removeAttribute('data-src');
					}
					if (!target.api?.loadingEnabled) {
						target.api?.startLoad();
					}
				} else {
					if (target.api?.loadingEnabled) {
						target.api?.stopLoad();
					}
				}
			}
		});
	},
	{ threshold: [0, 1], rootMargin: '-300px 0px -100px 0px' },
);
const lazyVideos = Array.from(document.querySelectorAll('hls-video'));
lazyVideos.forEach(video => {
	video.config = {
		maxBufferLength: 15,
		maxBufferSize: 15 * 1024 * 1024,
		maxBufferHole: 0.5,
		lowBufferLength: 3,
		lowBufferWatchdogPeriod: 0.5,
		autoStartLoad: true,
		startLevel: -1,
		capLevelToPlayerSize: true,
	};
	videoObserver.observe(video);
});

// Compute indentation
const updateIndent = () => {
	const grid = document.querySelector('.grid[data-layout="base"][data-indent]');
	if (!grid) {
		return;
	}
	const style = getComputedStyle(grid);
	const columns = style.gridTemplateColumns.split(' ');
	const columnWidth = parseFloat(columns[0]);

	if (columnWidth) {
		document.body.style.setProperty('--indent', `${columnWidth + 12}px`);
	}
};

const resizeObserver = new ResizeObserver(() => {
	updateIndent();
});
resizeObserver.observe(document.body);
updateIndent();

// const swiperWithCaptions = Array.from(
// 	document.querySelectorAll('[data-slider-with-captions]'),
// );
// swiperWithCaptions.forEach(swiper => {
// 	swiper.addEventListener("swiperslidechange", ())
// })
const swiperEls = Array.from(
	document.querySelectorAll('swiper-container.slider-front'),
);

swiperEls.forEach(swiperEl =>
	swiperEl.addEventListener('swiperautoplaytimeleft', e => {
		const [swiper, time, progress] = e.detail;

		swiperEl
			.closest('.slider')
			?.style.setProperty(
				'--swiper-progress',
				`${((1 / swiper.slides.length) * (swiper.realIndex + 1) - progress / swiper.slides.length) * 100}%`,
			);
	}),
);

const sortableTables = Array.from(
	document.querySelectorAll('table:has(th button)'),
) as HTMLTableElement[];

sortableTables.forEach(table => {
	const liveRegion = table.previousElementSibling;
	let toSort = [];
	let direction = 'asc';

	table.addEventListener('click', e => {
		const button = e.target.closest('thead button');

		if (button) {
			const cell = button.parentNode;
			const tbody = table.querySelector('tbody');
			const rows = tbody?.querySelectorAll('tr');

			toSort = [];
			getRows(cell, rows);
			updateButton(cell);
			sortRows(rows);
			updateLiveRegion();
		}
	});

	const getRows = (cell, rows) => {
		const index = [...cell.parentNode.children].indexOf(cell);
		for (let i = 0; i < rows.length; i++) {
			const row = rows[i];
			if (row.classList.contains('table-details')) {
				toSort[(i - 1) / 2].push(row);
			} else {
				const cells = row.querySelectorAll(':where(td,th)');
				const sortValue =
					cells[index].dataset.sortValue ?? cells[index].innerText;
				toSort.push([sortValue, row.cloneNode(true)]);
			}
		}
	};

	const sortRows = rows => {
		toSort.sort(function (a, b) {
			const comp = a[0].localeCompare(b[0], document.documentElement.lang, {
				numeric: true,
			});
			return comp;
		});
		if (direction === 'descending') {
			toSort.reverse();
		}
		for (let i = 0; i < toSort.length; i++) {
			const index = rows.length === toSort.length ? i : i * 2;
			const row = rows[index] as HTMLTableRowElement;
			row.parentNode.replaceChild(toSort[i][1], row);
			if (toSort[i][2]) {
				(toSort[i][1] as HTMLTableRowElement).after(toSort[i][2]);
			}
		}
	};

	const updateButton = cell => {
		const sortedColumn = table.querySelector('[aria-sort]');
		if (sortedColumn && sortedColumn !== cell) {
			sortedColumn.removeAttribute('aria-sort');
		}
		direction =
			cell.getAttribute('aria-sort') === 'ascending'
				? 'descending'
				: 'ascending';
		cell.setAttribute('aria-sort', direction);
	};
	const updateLiveRegion = () => {
		liveRegion.textContent = `Sorted ${direction}`;
		setTimeout(() => {
			liveRegion.textContent = ``;
		}, 1000);
	};
});

function throttle(fn, wait) {
	let last = 0;
	return (...args) => {
		const now = Date.now();
		if (now - last >= wait) {
			last = now;
			fn.apply(this, args);
		}
	};
}

function debounce(fn, wait) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), wait);
	};
}

const t = throttle(() => {
	document.documentElement.classList.toggle('not-on-top', window.scrollY > 0);
	document.documentElement.classList.toggle(
		'below-fold',
		window.scrollY > window.innerHeight,
	);
}, 100);
const d = debounce(function (e) {
	document.documentElement.classList.toggle('not-on-top', window.scrollY > 0);
	document.documentElement.classList.toggle(
		'below-fold',
		window.scrollY > window.innerHeight,
	);
}, 250);

window.addEventListener('scroll', () => {
	t();
	d();
});

// XHR Forms
const xhrForms = Array.from(
	document.querySelectorAll('[data-xhr]'),
) as HTMLFormElement[];

xhrForms.forEach(form => {
	form.addEventListener('submit', async e => {
		e.preventDefault();
		const output = (form.querySelector("[role='status']") ??
			form.nextElementSibling) as HTMLElement | null;
		if (output) {
			output.hidden = true;
			output.innerHTML = '';
		}

		const params = new FormData(form);

		let response;
		try {
			response = await fetch('/', {
				method: form.method,
				headers: {
					Accept: 'application/json',
				},
				body: params,
			});
		} catch (error) {
			console.error('There was an error', error);
		}

		if (response?.ok) {
			const json = await response.json();
			if (output) {
				output.innerHTML = json.message;
				output.hidden = false;
			}
			if (form.dataset.xhr === 'hideAfterSuccess') {
				form.hidden = true;
			}
			form.dispatchEvent(new Event('success'));
		} else {
			const json = await response?.json();
			if (output) {
				output.innerHTML = json.message;
				output.hidden = false;
			}
		}
	});
});

const sliderWithCaptions = Array.from(
	document.querySelectorAll('swiper-container:has(swiper-slide[data-caption])'),
);
const updateCaption = slider => {
	const caption = slider.swiper.slides[slider.swiper.realIndex].dataset.caption;
	// slider.querySelector('[slot="container-end"]').innerText = caption;
	const slot = slider.querySelector('[slot="container-end"]');
	if (slot) {
		slot.innerText = caption;
	}
};

sliderWithCaptions.forEach(slider => {
	updateCaption(slider),
		slider.addEventListener('swiperslidechange', () => updateCaption(slider));
});

const toggleAllButtons = Array.from(
	document.querySelectorAll('button[data-toggle-all]'),
) as HTMLButtonElement[];

toggleAllButtons.forEach(btn => {
	let expanded = btn.dataset.expanded === 'true';
	btn.addEventListener('click', () => {
		Array.from(
			btn
				?.closest('section')
				?.querySelectorAll(
					`[aria-expanded='${expanded ? 'true' : 'false'}']`,
				) ?? [],
		).forEach(btn => btn.click());

		expanded = !expanded;
		// Update button text
		const tmp = btn.dataset.toggleText ?? '';
		btn.dataset.toggleText = btn.innerText;
		btn.innerText = tmp;
	});
});

const imageContainers = Array.from(
	document.querySelectorAll('.table-projectindex .images'),
) as HTMLElement[];

let os;
const scrollbarObserver = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (
			!entry.isIntersecting ||
			entry.target.hasAttribute('data-overlayscrollbars')
		) {
			return;
		}
		os.OverlayScrollbars(
			{
				target: entry.target,
				elements: { viewport: entry.target },
			},
			{
				overflow: { x: 'scroll', y: 'hidden' },
				scrollbars: {
					autoHide: 'never',
					visibility: 'visible',
				},
			},
		);
	});
});
const initOverlayScrollbars = async containers => {
	import('overlayscrollbars/overlayscrollbars.css');
	os = await import('overlayscrollbars');
	containers.forEach(container => {
		scrollbarObserver.observe(container);
	});
};

if (imageContainers.length && document.body.dataset.site === 'kusser-usa') {
	initOverlayScrollbars(imageContainers);
}

imageContainers.forEach(container => {
	let isDragging = false;
	let startX: number;
	let scrollLeft: number;

	container.addEventListener('mousedown', e => {
		isDragging = true;
		container.classList.add('dragging');
		if (e.target.classList.contains('os-scrollbar-handle')) {
			return;
		}
		startX = e.pageX - container.offsetLeft;
		scrollLeft = container.scrollLeft;
	});

	container.addEventListener('mouseleave', e => {
		isDragging = false;
		container.classList.remove('dragging');
		if (e.target.classList.contains('os-scrollbar-handle')) {
			return;
		}
	});

	container.addEventListener('mouseup', e => {
		isDragging = false;
		container.classList.remove('dragging');
		if (e.target.classList.contains('os-scrollbar-handle')) {
			return;
		}
	});

	container.addEventListener('mousemove', e => {
		if (e.target.classList.contains('os-scrollbar-handle')) {
			return;
		}
		if (!isDragging) return;
		e.preventDefault();
		const x = e.pageX - container.offsetLeft;
		const walk = (x - startX) * 1; // speed multiplier
		container.scrollLeft = scrollLeft - walk;
	});
});
